module.exports = __webpack_public_path__ + "img/pipay.08dbd33c.png";